import React, { PropsWithChildren } from 'react';
import moment from 'moment';
import { getDateTimeMoment } from 'utils/dates';
import { TimelineProvider } from 'components/timeline';
import { useJobsitePulse } from './JobsitePulseProvider';

export function JobsitePulseTimelineProvider(
  props: PropsWithChildren<unknown>,
): React.ReactElement {
  const { children } = props;

  const { applyFilter, date, time } = useJobsitePulse();
  const currentTime = getDateTimeMoment({ date, time });

  const handleCurrentTimeChange = (newCurrentTime: moment.Moment): void => {
    applyFilter({
      time: moment(newCurrentTime).format('hh:mm A'),
    });
  };

  return (
    <TimelineProvider
      currentTime={currentTime}
      onCurrentTimeChange={handleCurrentTimeChange}
    >
      {children}
    </TimelineProvider>
  );
}
